import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandshake, faRobot, faChartLine } from '@fortawesome/free-solid-svg-icons';

const Home = () => {
  return (
    <main className="flex-grow">
      <div className="container mx-auto w-4/5">
        <div className="text-center mt-6"> {/* Adjusted mt-12 to mt-6 for less top margin */}
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Welcome to eHandshake</h1>
          <h3 className="text-xl font-semibold mb-2 text-brand">A Collaborative Marketing Network for Local Businesses</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-4"> {/* Adjusted mt-8 to mt-4 for less grid margin */}
            <div className="bg-white p-6 rounded-lg shadow-md">
              <FontAwesomeIcon icon={faHandshake} className="text-4xl text-brand mb-4" />
              <h3 className="text-xl font-semibold mb-2">Connect Locally</h3>
              <p className="text-gray-600">Connecting local, non-competing businesses to supercharge marketing and referral efforts. Local businesses bond together to promote one another on various social and business media platforms, including likes, shares emoji stickers. It's all about getting your brand into different audiences.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <FontAwesomeIcon icon={faRobot} className="text-4xl text-brand mb-4" />
              <h3 className="text-xl font-semibold mb-2">AI-Powered</h3>
              <p className="text-gray-600">Leverage AI to grow your business network. From onboarding to business matching to referral generation, AI plays a key role in the eHandshake system. We align you with the best of the best and use the power of teams to increase exposure and find new customers.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <FontAwesomeIcon icon={faChartLine} className="text-4xl text-brand mb-4" />
              <h3 className="text-xl font-semibold mb-2">Grow Together</h3>
              <p className="text-gray-600">Build lasting business relationships. Use your marketing power in a team atmosphere. Everyone supports each other. Everyone promotes each other. And you have the power of exceptional reviews and scores to back up any referral of your teammates.</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Home;